module.exports = __webpack_public_path__ + "vi.svg?d81c1ed35a04e6565d332922550c96b7";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/vi.svg
// module id = 1166
// module chunks = 27